module.exports = __webpack_public_path__ + "static/media/dokapi-logo-dark-green-fern.35aa6a09.svg";